import { t as createLogger } from "./app.shared-CmP4XLF_.js";

var log = createLogger("recently-viewed");

var recently_viewed_default = (() => {
    if (!customElements.get("recently-viewed")) customElements.define("recently-viewed", class RecentlyViewed extends HTMLElement {
        constructor() {
            super();
            window.Shopify = window.Shopify || {};
            window.Shopify.recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
        }
        show() {
            this.closest(".shopify-section").setAttribute("data-recent-loaded", true);
            this.closest('.shopify-section:not([id*="drawer"])')?.classList.add("my-3xl", "tablet:my-xl");
            log("lifecycle", "shown");
        }
        async loadProduct(handle) {
            const url = location.href.match(`/products/([^?]+)`);
            if (url && handle === url[1]) {
                log("network", "skip current product", {
                    handle: handle
                });
                return;
            }
            log("network", "fetching product card", {
                handle: handle
            });
            try {
                const response = await fetch(`${Shopify.routes.root || "/"}products/${handle}?view=card`);
                if (!response.ok) {
                    log("errors", "fetch failed", {
                        handle: handle,
                        status: response.status,
                        statusText: response.statusText
                    });
                    if (response.status === 404) {
                        Shopify.recentlyViewed = Shopify.recentlyViewed.filter(h => h !== handle);
                        localStorage.setItem("recentlyViewed", JSON.stringify(Shopify.recentlyViewed));
                        log("network", "removed 404 handle from localStorage", {
                            handle: handle
                        });
                    }
                    throw Error(response.statusText);
                }
                const text = await response.text();
                const html = (new DOMParser).parseFromString(text, "text/html");
                const item = document.createElement("li");
                item.classList.add("w-grid", "shrink-0", "relative", "snap-start", "tablet:snap-center");
                item.setAttribute("data-slide", "");
                item.innerHTML = html.body.innerHTML;
                this.container.appendChild(item);
                this.classList.remove("hidden");
                log("network", "product card loaded", {
                    handle: handle
                });
            } catch (error) {
                log("errors", "loadProduct failed", {
                    handle: handle,
                    error: error
                });
                console.warn("Could not load product: " + handle + ". " + error);
            }
        }
        async loadProducts() {
            log("lifecycle", "loadProducts start", {
                count: Shopify.recentlyViewed.length
            });
            try {
                const result = await Promise.all(Shopify.recentlyViewed.map(handle => this.loadProduct(handle.split("#")[0])));
                this.show();
                this.sliderComponent.outerHTML = this.sliderComponent.outerHTML;
                this.querySelector("slider-controls")?.dispatchEvent(new CustomEvent("slider-controls:refresh"));
                log("lifecycle", "loadProducts complete", {
                    loaded: result.length
                });
            } catch (error) {
                log("errors", "loadProducts failed", {
                    error: error
                });
                console.error("Error loading products:", error);
            }
        }
        connectedCallback() {
            this.container = this.querySelector("[data-slider]");
            this.sliderComponent = this.querySelector("slider-component");
            log("lifecycle", "connected", {
                hasContainer: !!this.container,
                hasSlider: !!this.sliderComponent,
                hasIO: "IntersectionObserver" in window,
                storedCount: Shopify?.recentlyViewed?.length ?? 0
            });
            if (!this.container) {
                log("errors", "aborting — no [data-slider] container found inside host");
                return;
            }
            if (!Shopify?.recentlyViewed?.length) {
                log("lifecycle", "aborting — no recently viewed products in localStorage");
                return;
            }
            const trigger = this.closest(".shopify-section")?.previousElementSibling ?? null;
            if ("IntersectionObserver" in window && trigger) {
                log("lifecycle", "observing trigger sibling", {
                    tag: trigger.tagName,
                    class: typeof trigger.className === "string" ? trigger.className : ""
                });
                let wasIntersecting = false;
                new IntersectionObserver((entries, obs) => {
                    const entry = entries[0];
                    const isIntersecting = entry?.isIntersecting ?? false;
                    if (isIntersecting !== wasIntersecting) {
                        wasIntersecting = isIntersecting;
                        log("events", "intersection changed", {
                            isIntersecting: isIntersecting,
                            intersectionRatio: entry?.intersectionRatio ?? 0
                        });
                    }
                    if (isIntersecting) {
                        obs.disconnect();
                        this.loadProducts();
                    }
                }, {
                    rootMargin: "200px 0px"
                }).observe(trigger);
            } else {
                log("lifecycle", "no trigger/IntersectionObserver — loading immediately");
                this.loadProducts();
            }
        }
    });
})();